import React from "react"

const HorizontalThreeDots = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.37584 12.1477C6.37584 11.557 6.16107 11.0201 5.73154 10.6174C5.30201 10.1879 4.79195 10 4.1745 10C3.58389 10 3.07383 10.2148 2.6443 10.6174C2.21477 11.047 2 11.557 2 12.1477C2 12.5503 2.10738 12.8993 2.2953 13.2483C2.48322 13.5705 2.75168 13.8389 3.07383 14.0268C3.39597 14.2148 3.77181 14.3221 4.14765 14.3221C4.55034 14.3221 4.92617 14.2148 5.27517 14.0268C5.59732 13.8389 5.86577 13.5705 6.08054 13.2483C6.26846 12.8993 6.37584 12.5503 6.37584 12.1477ZM14.1611 12.1477C14.1611 11.557 13.9463 11.0201 13.5436 10.6174C13.1141 10.1879 12.604 10 12.0134 10C11.4228 10 10.9128 10.2148 10.4832 10.6174C10.0537 11.047 9.86577 11.557 9.86577 12.1477C9.86577 12.5503 9.97316 12.8993 10.1611 13.2483C10.349 13.5705 10.6174 13.8389 10.9396 14.0268C11.2617 14.2148 11.6376 14.3221 12.0134 14.3221C12.4161 14.3221 12.7919 14.2148 13.1141 14.0268C13.4362 13.8389 13.7047 13.5705 13.8926 13.2483C14.0537 12.8993 14.1611 12.5503 14.1611 12.1477ZM22 12.1477C22 11.557 21.7852 11.0201 21.3557 10.6174C20.9262 10.1879 20.4161 10 19.8255 10C19.2081 10 18.698 10.2148 18.2685 10.6174C17.8389 11.047 17.6242 11.557 17.6242 12.1477C17.6242 12.5503 17.7315 12.8993 17.9195 13.2483C18.1074 13.5705 18.3758 13.8389 18.7248 14.0268C19.047 14.2148 19.4228 14.3221 19.8524 14.3221C20.255 14.3221 20.604 14.2148 20.9262 14.0268C21.2483 13.8389 21.5168 13.5705 21.7047 13.2483C21.8926 12.8993 22 12.5503 22 12.1477Z"
        fill="#1C1F21"
      />
    </svg>
  )
}

export default HorizontalThreeDots
